import { Pipe, PipeTransform } from '@angular/core';
import { ReviewTargetModel } from '@models/reviewTarget.model';
import { ReviewTargetSource } from '@enums/reviewTargetSource.enum';

@Pipe({
  name: 'isIntegratedWithFacebook'
})
export class IsIntegratedWithFacebookPipe implements PipeTransform {

  transform(reviewTarget: ReviewTargetModel): boolean {
    return !!reviewTarget.source && reviewTarget.source.includes(ReviewTargetSource.facebook)
  }

}
